// The website's own Category (custom.category) and Type for the Shopify category picked at intake (Tim, 19 Oct): the form's
// category fills the store's Category field the way staff fill it by hand, and Type follows it by the same map as the hourly
// "Type follows Category" job and qa-details (site-work/collections/category-to-type-map.json). The most specific prefix of the
// taxonomy id wins, so "aa-1-13-13" (Hoodies) beats "aa-1-13" (any top). Values were read off how the store's 2,500 listings
// were filled by hand on 19 Oct. A category with no match (e.g. lingerie) leaves the field empty for QA to flag.

const BY_TAXONOMY: [string, string[]][] = [
  // tops
  ['aa-1-13', ['T-shirts']], ['aa-1-1-2', ['T-shirts']], ['aa-1-13-8', ['T-shirts']], ['aa-1-13-9', ['T-shirts']],
  ['aa-1-13-7', ['Shirts']], ['aa-1-13-5', ['Shirts']], ['aa-1-13-6', ['Shirts']], ['aa-1-13-1', ['Shirts']],
  ['aa-1-13-13', ['Hoodies', 'Sweaters/Sweatshirts']], ['aa-1-1-7', ['Hoodies', 'Sweaters/Sweatshirts']], ['aa-1-1-7-2', ['Hoodies', 'Sweaters/Sweatshirts']],
  ['aa-1-13-14', ['Sweaters/Sweatshirts']], ['aa-1-13-12', ['Sweaters/Sweatshirts']], ['aa-1-13-3', ['Sweaters/Sweatshirts']], ['aa-1-1-7-4', ['Sweaters/Sweatshirts']],
  ['aa-1-13-15', ['Corsets']], ['aa-1-6-15', ['Corsets']],
  // outerwear
  ['aa-1-10', ['Jackets']], ['aa-1-1-8', ['Jackets']], ['aa-1-1-7-5', ['Jackets']], ['aa-1-10-6', ['Vests']], ['aa-1-1-8-1', ['Vests']],
  // bottoms
  ['aa-1-12', ['Pants']], ['aa-1-1-1', ['Pants']], ['aa-1-12-4', ['Pants', 'Denim']], ['aa-1-24-1-1', ['Denim']],
  ['aa-1-14', ['Shorts']], ['aa-1-1-4', ['Shorts']],
  ['aa-1-4', ['Dresses']], ['aa-1-15', ['Skirts']],
  // accessories (staff add Accessories alongside the specific one)
  ['aa-2', ['Accessories']], ['aa-2-6', ['Accessories', 'Belts']], ['aa-2-5', ['Accessories', 'Belts']],
  ['aa-2-17', ['Accessories', 'Hats']], ['aa-2-27', ['Accessories', 'Eyewear']], ['aa-1-18', ['Accessories']],
  ['aa-6', ['Accessories', 'Jewelry']], ['aa-6-11', ['Accessories', 'Watches']], ['aa-6-12', ['Accessories', 'Watches']],
  ['aa-4', ['Accessories']], ['aa-4-3', ['Accessories', 'Jewelry']], ['aa-4-1', ['Accessories', 'Jewelry']],
  ['aa-5', ['Accessories', 'Bags']], ['aa-5-5', ['Accessories', 'Wallets']], ['lb', ['Accessories', 'Bags']],
  ['aa-8', ['Shoes']], ['aa-8-10', ['Heels']],
]

// the same order as site-work/collections/category-to-type-map.json: the first category the piece has decides its Type
const TYPE_OF: [string, string][] = [
  ['Jackets', 'Outerwear'], ['Vests', 'Outerwear'], ['Hoodies', 'Hoodies, Sweatshirts & Knits'], ['Sweaters/Sweatshirts', 'Hoodies, Sweatshirts & Knits'],
  ['T-shirts', 'Tees & Long Sleeves'], ['Shirts', 'Shirts'], ['Dresses', 'Dresses, Skirts & Tops'], ['Corsets', 'Dresses, Skirts & Tops'], ['Skirts', 'Dresses, Skirts & Tops'],
  ['Shorts', 'Shorts'], ['Denim', 'Denim'], ['Pants', 'Pants'], ['Shoes', 'Footwear'], ['Heels', 'Footwear'], ['Belts', 'Belts & Buckles'], ['Hats', 'Hats'],
  ['Eyewear', 'Eyewear'], ['Bags', 'Bags'], ['Wallets', 'Wallets & Small Leather Goods'], ['Jewelry', 'Jewelry'], ['Watches', 'Jewelry'], ['Art', 'Other Accessories'], ['Accessories', 'Other Accessories'],
]

/** The store's Category values for a taxonomy id ("aa-1-13-13" → Hoodies, Sweaters/Sweatshirts); empty when nothing fits. */
export function siteCategories(taxonomyId: string | undefined): string[] {
  if (!taxonomyId) return []
  let best: [string, string[]] | null = null
  for (const rule of BY_TAXONOMY) {
    const [prefix] = rule
    if ((taxonomyId === prefix || taxonomyId.startsWith(prefix + '-')) && (!best || prefix.length > best[0].length)) best = rule
  }
  return best ? [...best[1]] : []
}

/** Type for a set of categories, by map order (Accessories only when nothing more specific is there). */
export function siteType(categories: string[]): string | null {
  return TYPE_OF.find(([c]) => categories.includes(c))?.[1] ?? null
}
